import { SRPRS_DEV } from '../env'
import { config } from './config'
import createMetrics from './middleware/createMetrics'

export function getMetrics() {
  return createMetrics({
    ...config,
    debug: SRPRS_DEV,
  })
}
